import { Navigate, Outlet } from 'react-router-dom-v5-compat';

import config from '@/config';
import { AdminFirewall } from '@/modules/auth/components/AdminFirewall';
import { NonDemoFirewall } from '@/modules/auth/components/NonDemoFirewall';

export const SettingsPage = () => (
    <NonDemoFirewall>
        <AdminFirewall firewall={<Navigate to={config.routes.home} replace />}>
            <Outlet />
        </AdminFirewall>
    </NonDemoFirewall>
);
